// modules/DebugHelper.js
// 调试辅助模块 - 统一管理调试日志输出
import StorageHelper from './StorageHelper.js';

export default class DebugHelper {
    // 是否启用调试模式（可以通过URL参数或localStorage控制）
    static get DEBUG_MODE() {
        // 检查URL参数
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('debug') === 'true') {
            return true;
        }
        
        // 检查localStorage（使用StorageHelper）
        return StorageHelper.getItem('debugMode', 'false') === 'true';
    }
    
    /**
     * 调试日志（仅在调试模式下输出）
     * @param {...any} args - 日志参数
     */
    static log(...args) {
        if (this.DEBUG_MODE) {
            console.log('[DEBUG]', ...args);
        }
    }
    
    /**
     * 警告日志（始终输出，但可以标记为调试）
     * @param {...any} args - 日志参数
     */
    static warn(...args) {
        if (this.DEBUG_MODE) {
            console.warn('[WARN]', ...args);
        }
    }
    
    /**
     * 错误日志（始终输出，但可以标记为调试）
     * @param {...any} args - 日志参数
     */
    static error(...args) {
        // 错误始终输出，但可以添加调试标记
        if (this.DEBUG_MODE) {
            console.error('[ERROR]', ...args);
        } else {
            // 生产环境也输出错误，但不显示调试标记
            console.error(...args);
        }
    }
    
    /**
     * 信息日志（仅在调试模式下输出）
     * @param {...any} args - 日志参数
     */
    static info(...args) {
        if (this.DEBUG_MODE) {
            console.info('[INFO]', ...args);
        }
    }
    
    /**
     * 分组日志（仅在调试模式下输出）
     * @param {string} label - 分组标签
     * @param {Function} callback - 回调函数
     */
    static group(label, callback) {
        if (this.DEBUG_MODE) {
            console.group(label);
            if (callback) callback();
            console.groupEnd();
        } else if (callback) {
            callback();
        }
    }
}

